import { toast } from 'react-hot-toast';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import SPONSORSHIP from '../../api/ressources/App/sponsorships';

export const getSponsorships = createAsyncThunk(
  '/sponsorships/getAll',
  async () => {
    const response = await SPONSORSHIP.getSponsorship()
    return response.data
  }
);

export const createSponsorship = createAsyncThunk(
  '/sponsorships/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await SPONSORSHIP.createSponsorship(data)
      return response.data
    } catch (err) {
      if (err.response?.status === 422) return rejectWithValue(err.response.data);
      // Handled here rather than by errorsInterceptor, which would reload the page
      if (err.response?.status === 403) return rejectWithValue({ forbidden: true });
      throw err;
    }
  }
);

const initialState = {
  sponsorships: [],
  godsonForm: {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    phone_country_code: 'FR',
    godson_agreement: false
  },
  isSubmitting: false,
  error: null,
  formErrors: {}
};

export const sponsorshipsSlice = createSlice({
  name: 'sponsorships',
  initialState,
  reducers: {
    resetSponsorships(state) {
      state.sponsorships = initialState.sponsorships;
    },
    resetErrorAndForm(state) {
      state.error = initialState.error;
      state.godsonForm = initialState.godsonForm;
    },
    updateGodsonForm(state, { payload }) {
      state.godsonForm = payload;
    },
    updateFormErrors(state, { payload }) {
      if (Object.keys(payload).length > 0) state.formErrors = payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getSponsorships.fulfilled, (state, { payload }) => {
      state.sponsorships = payload;
    })
    builder.addCase(createSponsorship.pending, (state) => {
      state.isSubmitting = true;
    })
    builder.addCase(createSponsorship.fulfilled, (state, { payload }) => {
      state.sponsorships = [...state.sponsorships, payload];
      state.isSubmitting = false;
      state.godsonForm = initialState.godsonForm;
      toast.success('Parrainage enregistré, un agent Hosman contactera votre filleul prochainement', { duration: 5000 });
    })
    builder.addCase(createSponsorship.rejected, (state, { payload }) => {
      if (!payload) toast.error("Une erreur s'est produite, veuillez réessayer plus tard", { duration: 3000 });
      else if (payload.forbidden) toast.error('Vous ne pouvez pas effectuer cette action', { duration: 3000 });
      else if (payload.error.message.error_type === 'validation_error') state.formErrors = payload.error.message.errors;
      else state.error = payload.error;

      state.isSubmitting = false;
    })
  },
})

export const { resetSponsorships, updateGodsonForm, resetErrorAndForm, updateFormErrors } = sponsorshipsSlice.actions;

export default sponsorshipsSlice.reducer;
